import { render, staticRenderFns } from "./DevicePrice.vue?vue&type=template&id=59509d10&scoped=true&"
import script from "./DevicePrice.vue?vue&type=script&lang=ts&"
export * from "./DevicePrice.vue?vue&type=script&lang=ts&"
import style0 from "./DevicePrice.vue?vue&type=style&index=0&id=59509d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59509d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59509d10')) {
      api.createRecord('59509d10', component.options)
    } else {
      api.reload('59509d10', component.options)
    }
    module.hot.accept("./DevicePrice.vue?vue&type=template&id=59509d10&scoped=true&", function () {
      api.rerender('59509d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/ob1/DevicePrice.vue"
export default component.exports